import styled from '@emotion/styled'
import { AnchorTag } from 'components/core/AnchorTag'
import { MOBILE_BREAKPOINT } from 'constants/app.constants'
import { SPACING } from 'constants/spacing.constants'
import { ReactNode } from 'react'

const StyledConfirmShipmentDetailsWidgetEditableFieldWrapper = styled.div`
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    position: relative;

    .confirmShipmentDetailsWidgetEditableFieldWrapper__anchor {
        display: none;
        position: absolute;
        top: 0;
        right: ${SPACING.sm};
        cursor: pointer;
        user-select: none;
    }

    &:hover .confirmShipmentDetailsWidgetEditableFieldWrapper__anchor {
        display: block;
        animation: fadeIn 0.2s;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}px) {
        /* Always visible on mobile */
        .confirmShipmentDetailsWidgetEditableFieldWrapper__anchor {
            display: block;
        }
        &:hover .confirmShipmentDetailsWidgetEditableFieldWrapper__anchor {
            animation: none;
        }
    }
`

export const ConfirmShipmentDetailsWidgetEditableFieldWrapper = ({
    children,
    onRemove,
}: {
    children: ReactNode
    onRemove: () => void
}) => {
    return (
        <StyledConfirmShipmentDetailsWidgetEditableFieldWrapper>
            {children}
            <AnchorTag
                className="confirmShipmentDetailsWidgetEditableFieldWrapper__anchor"
                underline
                variant="caption"
                color="secondary"
                onClick={(e) => {
                    e.preventDefault()
                    onRemove()
                }}
            >
                Remove
            </AnchorTag>
        </StyledConfirmShipmentDetailsWidgetEditableFieldWrapper>
    )
}
